import React from "react";
import "./About.css"; // ✅ External CSS for About Page
import "bootstrap/dist/css/bootstrap.min.css";

const About = () => {
  return (
    <div className="about-container">
      <h1 className="about-title">About Us</h1>
      <p className="about-text">
        Every bite is a celebration of our ethnic Indian flavours and rich
        heritage at <b>Amman Sweets</b>. Made with traditionally followed and
        loved recipes that recite the epic stories of Indian flavours, at Amman
        Sweets, we make our delicious delights with love.
      </p>

      <p className="about-text">
        <b>We bring home a reason to celebrate!</b>
      </p>

      <p className="about-text">
        A story that began in 2004 is now a beloved and trusted name in homes
        across Tamil Nadu, with 25 outlets and counting.
      </p>

      <p className="about-text">
        We’ve proven ourselves to be a harbinger of pride and have withstood the
        test of time amidst other brands, securing a sweet spot in people's
        hearts with our Indian snacks and savouries. Using our whimsically
        inventive ideas and constant effort to manufacture different varieties
        of bites.
      </p>

      <h3 className="section-title">Why Choose Us?</h3>
      <p className="about-text">
        As a testament to our rich and varied culinary heritage, we at Amman
        Sweets are committed to crafting the finest and most treasured healthy
        Indian snacks. We believe that life's every little glee should be
        celebrated every day with a little bit of indulgence. Our exclusive
        range of delicacies is made with the purest, locally sourced ingredients
        and authentic age-old recipes that meet the highest standards of safety.
      </p>

      <h3 className="section-title">What makes us special?</h3>
      <ul className="special-list">
        <li>
          We use only organic, cold-pressed groundnut oil, and our oil is never
          reused.
        </li>
        <li>
          You will receive our love through our mouth-watering sweets online.
        </li>
        {/* <li>
          We make all our sweets and snacks in our Amman factory, sprawling
          across 5 acres on the Chennai-Trichy highway.
        </li> */}
        <li>
          We use only pounded flour, ground at our mill, to make all our bites
          because we believe in providing the best diet snacks.
        </li>
        <li>
          We are a strong team of 1500 people, with a majority of women, who
          help each other grow together.
        </li>
      </ul>

      <p className="about-text">
        The next time you grab your sweet boxes at Amman Sweets, remember they
        were made with love by us and meant to reach your heart.
      </p>
    </div>
  );
};

export default About;
